import { useEffect } from 'react';
import PiwikPro from '@piwikpro/react-piwik-pro';

const usePiwikProInit = (countryCode: string | undefined) => {
  useEffect(() => {
    if (!countryCode) return;

    const siteIdMap: Record<string, string> = {
      DE: 'd56e93df-0d7b-4863-8d6a-005aed52e5f2',
      CL: '5253ec99-7338-4a58-ad13-90dc836bb406',
      IN: 'aa728744-a90a-48a5-b5ef-2349e875b628',
      US: '7b29533f-b83b-4508-82f4-118f4fe4c7a1',
      PL: '5b06ae34-cf7f-42e1-8805-5b58248d983d',
      GB: '71b30b92-92a4-44ef-96e0-b4af80631782',
      ZA: '32dafc1d-7910-4919-a5a4-1da56edd33f7',
    };

    const siteId = siteIdMap[countryCode];

    try {
      if (!siteId) {
        console.warn(`No Piwik site ID configured for country: ${countryCode}`);
        throw new Error(`No Piwik site ID configured for country: ${countryCode}`);
      }
    } catch (error) {
      console.error(error);
      return;
    }

    // make sure we only initialize once
    if (!(window as any).__piwikInitialized) {
      PiwikPro.initialize(siteId, 'https://dkms.containers.piwik.pro');
      (window as any).__piwikInitialized = true;
    }
  }, [countryCode]);
};

export default usePiwikProInit;
